<template>
  <div class="day-content" :class="emptySchedule ? 'empty-schedule' : ''" :style="contentColor">
    <div class="day-number" :style="dayNumberColor">
      <span>{{ dayNumberText.padStart(2, '0') }}</span>
    </div>

    <div v-if="emptySchedule" class="no-schedule-week">
      <span class="no-schedule-week-message">Nenhum evento</span>
    </div>

    <div v-if="emptySchedule" class="no-schedule-day">
      <span class="no-schedule-day-message">Não há nenhum conteúdo nesse dia</span>
      <img
          src="https://jaleko-files.s3-sa-east-1.amazonaws.com/topicos-imagem/626815539e095_garota_estudando.svg"
          alt="Garota estudando." class="no-schedule-day-image">
    </div>

    <v-menu v-model="menu" :close-on-content-click="false" :close-on-click="false" :min-width="desktopView ? 40 : 70"
            :max-height="desktopView ? 70 : 40" content-class="day-marker-triangle" :offset-x="desktopView"
            :offset-y="!desktopView" :nudge-left="desktopView ? 15 : -6" :top="!desktopView"
            :nudge-bottom="desktopView ? 0 : 15">
      <template v-slot:activator="{ on, attrs }">
        <div class="menu-activator" v-bind="attrs" v-on="on">
        </div>
      </template>

      <div class="day-marker-background"></div>
    </v-menu>

    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="menuWidth" :min-width="210"
            :offset-x="desktopView" :offset-y="!desktopView" :nudge-right="desktopView ? 10 : 0"
            :nudge-top="desktopView ? 0 : 10" :top="!desktopView" content-class="schedule-menu-container">
      <template v-slot:activator="{ on, attrs }">
        <div class="menu-activator" v-bind="attrs" v-on="on">
        </div>
      </template>

      <v-card v-if="courses.length > 0" class="schedule-menu px-4 pb-4">
        <v-list class="py-0">
          <v-list-item class="pr-0">
            <v-list-item-content>
              <v-list-item-title class="schedule-menu-title">
                Conteúdo do dia {{ scheduleDate }}
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action class="d-flex flex-row">
              <v-btn v-if="false" icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn icon @click="deleteDayTasks">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>

              <v-btn icon @click="menu = !menu">
                <v-icon class="close-icon">mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-list class="py-0">
          <v-list-item>
            <v-list-item-content class="pt-0">
              <v-list-item-title>Curso(s):</v-list-item-title>
              <v-list-item-title class="schedule-course-list-item" v-for="course in courses" :key="course.id">
                {{ course.curso }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-checkbox color="#7C56F6" :input-value="completedTasks"
                          @change="status => completeOrResetTasks(status)"/>
            </v-list-item-action>
            <v-list-item-title class="schedule-menu-completed">Marcar como concluído</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-card-actions>
          <v-btn class="schedule-menu-button px-5" rounded dark @click="openDay">
            Abrir
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-else class="schedule-menu pa-6">
        <div class="no-schedule-content">
          <v-btn class="no-schedule-button" icon @click="menu = !menu">
            <v-icon class="close-icon">mdi-close</v-icon>
          </v-btn>

          <span class="no-schedule-message">Não há nenhum conteúdo nesse dia.</span>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import './style.scss'

import Swal from 'sweetalert2'
import {isToday} from 'date-fns'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "DayCellContent",

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  props: {
    color: String,
    dayNumberText: String,
    courses: Array,
    date: Date
  },

  data() {
    return {
      menu: false,
      windowWidth: window.innerWidth,
    }
  },

  computed: {
    ...mapGetters(['taskApiError']),

    scheduleDate() {
      return this.courses[0].start.getDate().toString().padStart(2, '0')
          + "/" + (this.courses[0].start.getMonth() + 1).toString().padStart(2, '0')
    },

    emptySchedule() {
      return this.courses.length === 0
    },

    completedTasks: {
      get() {
        return this.courses.every(course => {
          return course.modulos.every(module => module.tarefas.every(task => task.concluded))
        })
      },

      set(value) {
        this.courses.forEach(course => {
          course.modulos.forEach(module => module.tarefas.forEach(task => task.concluded = value))
        })
      }
    },

    contentColor() {
      const customStyle = {
        backgroundColor: this.color + '1F',
        borderColor: this.color,
        color: this.color,
        cursor: 'pointer'
      }

      return this.courses.length > 0 ? customStyle : null
    },

    dayNumberColor() {
      const customColor = {
        backgroundColor: this.color,
        color: '#fff'
      }

      return isToday(this.date) && this.courses.length > 0 ? customColor : null
    },

    desktopView() {
      return this.windowWidth >= 1024
    },

    mobileView() {
      return this.windowWidth <= 400
    },

    menuWidth() {
      if (this.mobileView) {
        return undefined
      }

      return this.courses.length > 0 ? 400 : 210
    }
  },

  methods: {
    ...mapActions(['completeOrResetDayTasks', 'removeEventDayCourses', 'resetApiTaskError']),

    onResize() {
      this.windowWidth = window.innerWidth
    },

    openDay() {
      const viewInfo = {
        view: 'timeGridDay',
        start: this.courses[0].start
      }

      this.$emit('change-view', viewInfo)
    },

    completeOrResetTasks(status) {
      let taskIds = []

      this.courses.forEach(course => {
        course.modulos.forEach(module => {
          module.tarefas.forEach(task => {
            taskIds.push(task.id)
          })
        })
      })

      const params = {
        eventDayId: this.courses[0].eventDayId,
        scheduleId: this.courses[0].scheduleId,
        taskIds,
        status,
      }
      this.completeOrResetDayTasks(params)
    },

    async deleteDayTasks() {
      const result = await Swal.fire({
        title: `Excluir conteúdo do dia ${this.scheduleDate}?`,
        text: '',
        footer: '',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: '#F47D3A',
        cancelButtonColor: '#FFF',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      })

      if (result.isConfirmed) {
        let taskIds = []
        let courseIds = []

        this.courses.forEach(course => {
          courseIds.push(course.id)

          course.modulos.forEach(module => {
            module.tarefas.forEach(task => {
              taskIds.push(task.id)
            })
          })
        })

        const params = {
          courseIds,
          eventDayId: this.courses[0].eventDayId,
          scheduleId: this.courses[0].scheduleId,
          taskIds,
        }

        await this.removeEventDayCourses(params)

        if (!this.taskApiError) {
          await Swal.fire(
              'Deletadas!',
              'Tarefas deletadas com sucesso'
          )
        } else {
          await Swal.fire(
              'Deletadas!',
              'Ocorreu um erro',
              'error'
          )

          this.resetApiTaskError()
        }
      }
    }
  }
}
</script>
